import API from './axios.js';


export const getNotesByCourtRef = (courtref) =>API.get(`note/note-by-court-ref?courtRef=${courtref}`);
export const getNoteByUser = (queryParams = '') => API.get(`note${queryParams}`);
export const getNoteByID = (id) => API.get(`note/${id}`);
export const saveNote = (noteData) => API.post('note', noteData);
export const updateNote = (noteData,id) => API.patch(`note/${id}`, noteData);
export const deleteNote = (id) => API.delete(`note/${id}`);

export const getNoteByUserId = (userId) => API.get(`notes/by-user/${userId}`);
//